import { calendarAssignments } from "./assignments.js";
import type { CalendarEvent, HomeworkAssignment, HomeworkRecord } from "./types.js";

export function assignmentDeletionPlan(
  classId: string,
  assignmentId: string,
  events: CalendarEvent[],
  assignments: HomeworkAssignment[],
  records: HomeworkRecord[],
) {
  const available = calendarAssignments(events, assignments);
  const assignment = available.find((item) => item.id === assignmentId && item.classId === classId);
  if (!assignment) throw new Error("找不到對應事項，請重新開啟事項目錄。");
  const affected = records.filter((item) => item.assignmentId === assignmentId);
  const event = events.find((item) => item.id === assignment.calendarEventId && item.classId === classId);
  const calendarEventId =
    event && !available.some((item) => item.id !== assignmentId && item.calendarEventId === event.id)
      ? event.id
      : undefined;
  // A second tab may save scores while the confirmation is open. Confirm that version again.
  const token = JSON.stringify([
    assignment.id,
    assignment.title,
    assignment.updatedAt,
    event?.updatedAt,
    affected.map((item) => [item.id, item.updatedAt]).sort((a, b) => String(a[0]).localeCompare(String(b[0]))),
  ]);
  return { assignment, records: affected, calendarEventId, token };
}
